export default __webpack_public_path__ + "static/media/search.fe3c5120.svg";